import { THEME_VARIANTS } from 'core/components/theme/theme-variant';

// Proper nouns that keep their capital mid-label.
const PROPER_NOUNS = new Set(['Branch', 'Plus', 'Gallagher', 'God']);
// A Title Case word after a space, slash or hyphen; acronyms (VIN), single letters (Coverage A) and mixed case
// (TransUnion, SqFt) don't match.
const TITLE_CASE_WORD = /([\s/-])([A-Z][a-z]+)\b/g;

export const toSentenceCase = (label) =>
  typeof label === 'string'
    ? label.replace(TITLE_CASE_WORD, (word, space, title) =>
        PROPER_NOUNS.has(title) ? word : `${space}${title.toLowerCase()}`
      )
    : label;

// New-look field labels are sentence case, like quote's; classic shows them as written (and uppercases them when shrunk).
export const fieldLabel = (theme, label) =>
  theme.themeVariant === THEME_VARIANTS.RESKIN ? toSentenceCase(label) : label;
